import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaUsers, FaTasks, FaCheckCircle, FaUserCheck } from 'react-icons/fa';
import './AdminStats.css';

const AdminStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const res = await axios.get('/api/admin/stats');
      setStats(res.data.data);
    } catch (error) {
      console.error('Failed to fetch stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading statistics...</div>;
  }

  if (!stats) {
    return <div className="error">Failed to load statistics</div>;
  }

  const { overview, tasksByStatus, tasksByPriority } = stats;

  return (
    <div className="admin-stats">
      <h2>Dashboard Statistics</h2>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'var(--primary-color)' }}>
            <FaUsers />
          </div>
          <div className="stat-details">
            <h3>{overview.totalUsers}</h3>
            <p>Total Users</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'var(--success-color)' }}>
            <FaUserCheck />
          </div>
          <div className="stat-details">
            <h3>{overview.activeUsers}</h3>
            <p>Active Users</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'var(--secondary-color)' }}>
            <FaTasks />
          </div>
          <div className="stat-details">
            <h3>{overview.totalTasks}</h3>
            <p>Total Tasks</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'var(--warning-color)' }}>
            <FaCheckCircle />
          </div>
          <div className="stat-details">
            <h3>{overview.completionRate}%</h3>
            <p>Completion Rate</p>
          </div>
        </div>
      </div>

      <div className="charts-grid">
        <div className="chart-card card">
          <h3>Tasks by Status</h3>
          <div className="chart-bars">
            {tasksByStatus.map((item) => (
              <div key={item._id} className="chart-bar-item">
                <div className="chart-label">{item._id}</div>
                <div className="chart-bar-container">
                  <div 
                    className="chart-bar"
                    style={{ 
                      width: `${(item.count / overview.totalTasks) * 100}%`,
                      background: item._id === 'completed' ? 'var(--success-color)' : 
                                 item._id === 'in-progress' ? 'var(--primary-color)' : 
                                 'var(--warning-color)'
                    }}
                  />
                  <span className="chart-value">{item.count}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="chart-card card">
          <h3>Tasks by Priority</h3>
          <div className="chart-bars">
            {tasksByPriority.map((item) => (
              <div key={item._id} className="chart-bar-item">
                <div className="chart-label">{item._id}</div>
                <div className="chart-bar-container">
                  <div 
                    className="chart-bar"
                    style={{ 
                      width: `${(item.count / overview.totalTasks) * 100}%`,
                      background: item._id === 'high' ? 'var(--danger-color)' : 
                                 item._id === 'medium' ? 'var(--warning-color)' : 
                                 'var(--success-color)'
                    }}
                  />
                  <span className="chart-value">{item.count}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminStats;
